"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStyles = void 0;

var parseStyles = function parseStyles(props, theme) {
  var fontsize = props.fontsize,
      color = props.themeColor;
  var fontSize = theme.fontSize,
      colors = theme.colors;
  var themedFontsize = fontsize && fontSize ? fontSize[fontsize] : fontSize.normal;
  var themedColor = color && colors ? colors[color] : colors.neutral;
  var sizeStyles = {
    width: themedFontsize || '24',
    height: themedFontsize || '24'
  };
  var colorStyles = {
    fill: themedColor || '#5A5D63'
  };
  return {
    sizeStyles: sizeStyles,
    colorStyles: colorStyles
  };
};

exports.parseStyles = parseStyles;